import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import {getDocumentsByCountry, hasValidOrNotApplicableFiles} from '../../../../utils/document';
import DossierActions, {createDownloadArchives, createDownloadDossier, createDownloadDossierOverview, createPrintDossier} from '../../../dossier/dossierActions/DossierActions';
import {useSubcontractorDetailsStore} from '../../SubcontractorDetailsStore';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import documentService from '../../../../services/document/DocumentService';
import {openOrSaveFile} from '../../../../utils/http';
import {recordGAEvent} from '../../../../utils/analytics';

function MenuView(props) {
  const organisation = useSelector(state => state.organisation);
  const {state: {subcontractor, documents, archives, dossierCountry}} = useSubcontractorDetailsStore();
  const noValidFiles = !hasValidOrNotApplicableFiles(getDocumentsByCountry(documents.list, dossierCountry));

  function handlePrintDossier() {
    recordGAEvent('BUYER_DOSSIER', 'Print supplier’s folder');
    authenticationService.authRedirect(documentService.getDossierOfSubcontractorPdfUrl(
      organisation.organisationId,
      subcontractor.details.organisationId,
      dossierCountry
    ))
      .then(authUrl => {
        openOrSaveFile(authUrl);
      });
  }

  function handleDownloadDossier() {
    recordGAEvent('BUYER_DOSSIER', 'Download supplier’s folder');
    authenticationService.authRedirect(documentService.getDossierOfSubcontractorZipUrl(
      organisation.organisationId,
      subcontractor.details.organisationId,
      dossierCountry
    ))
      .then(authUrl => {
        openOrSaveFile(authUrl);
      });
  }

  function handleDownloadArchivesDossier() {
    recordGAEvent('BUYER_ARCHIVES', 'Download supplier’s archives');
    authenticationService.authRedirect(
      documentService.getDossierArchivesOfSubcontractorZipUrl(
        organisation.organisationId,
        subcontractor.details.organisationId
      )
    )
      .then(authUrl => {
        openOrSaveFile(authUrl);
      });
  }

  const menuActions = [
    createDownloadDossierOverview(props.onDownloadDossierOverview),
    createPrintDossier(handlePrintDossier, 'dossier.print.standard', noValidFiles),
    createDownloadDossier(handleDownloadDossier, 'dossier.download.standard', noValidFiles),
    createDownloadArchives(handleDownloadArchivesDossier, isEmpty(archives.list))
  ];

  return (
    <div className="ml-3">
      <DossierActions
        big
        menuActions={menuActions}
      />
    </div>
  );
}

MenuView.propTypes = {
  onDownloadDossierOverview: PropTypes.func.isRequired
};

export default MenuView;
